import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgSmilieSad } from './svg/smilie-sad.svg.js';

/**
 * @deprecated - use RatingSad.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
var SmilieSad = function (props) {
    var title = props.title; props.size; props.legacyBoundingBox; var rest = __rest(props, ["title", "size", "legacyBoundingBox"]);
    return (jsx(SvgSmilieSad, __assign({ viewBox: "0 0 24 24", "aria-label": title, role: "img" }, rest, { width: 24, height: 24, "data-pp-icon": "SmilieSad" })));
};

export { SmilieSad as default };
//# sourceMappingURL=SmilieSad.js.map
